import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

export default function PelLogo({ isScrolled = false }: { isScrolled?: boolean }) {
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width:950px)");
  const suffix = i18n.language === "en" ? "-en" : "";
  const typePrefix = isMobile ? "-mobile" : isScrolled ? "-small" : "";
  const logoSrc = `/pelgroup${typePrefix}${typePrefix ? "" : "-logo"}${suffix}.svg`;

  return (
    <img
      className="pelgroup-logo"
      src={logoSrc}
      alt="PEL Group NTUA"
      style={{
        height: isScrolled ? "40px" : "",
      }}
    />
  );
}
